import React from 'react'

export type ContainerBoxProps = {
  children?: React.ReactNode
}

export const ContainerBox: React.FC<ContainerBoxProps> = ({ children }) => {
  return <div className="container-box">{children}</div>
}
